<div class="main user-profile">
    <div class="main-title">
        <h1>Dashboard</h1>
        <!-- Farm filter pill aligned with H1 -->
        <div class="farm-filter" (click)="toggleFarmMenu($event)">
            <span class="farm-filter__label">{{ currentFarmName }}</span>
            <span class="farm-filter__chevron" aria-hidden="true">
                <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6 9L12 15L18 9"
                        stroke="#FFFFFF"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </span>
            <ul class="farm-filter__menu" *ngIf="showFarmMenu">
                <li *ngFor="let farm of farmlist">
                    <button
                        type="button"
                        (click)="selectFarm(farm, $event)"
                        [class.active]="
                            farm.id === readingForm.get('farmId')?.value
                        "
                    >
                        {{ farm.name }}
                    </button>
                </li>
                <li *ngIf="farmlist?.length === 0" class="empty">No farms</li>
            </ul>
        </div>
    </div>

    <div class="key-metrics-container">
        <app-key-metric
            [infoName]="'Active Chicks'"
            [infoValue]="keyMetrics?.activeChicks ?? '-'"
            [infoIconSrc]="
                'assets/img/dashboard-key-metrics-icons/chick-icon.svg'
            "
            [infoIconAlt]="'Chick Icon'"
        ></app-key-metric>

        <app-key-metric
            [infoName]="'Mortality %'"
            [infoValue]="
                keyMetrics?.mortalityPercentage !== null &&
                keyMetrics?.mortalityPercentage !== undefined
                    ? keyMetrics?.mortalityPercentage + '%'
                    : '-'
            "
            [infoIconSrc]="
                'assets/img/dashboard-key-metrics-icons/mortality-icon.svg'
            "
            [infoIconAlt]="'Mortality Icon'"
        ></app-key-metric>

        <app-key-metric
            [infoName]="'Feed Consumption'"
            [infoValue]="keyMetrics?.feedingConsumption ?? '-'"
            [infoIconSrc]="
                'assets/img/dashboard-key-metrics-icons/feeding-icon.svg'
            "
            [infoIconAlt]="'Feeding Icon'"
        ></app-key-metric>

        <app-key-metric
            [infoName]="'Planned Weight VS Actual Weight'"
            [infoValue]="
                (keyMetrics?.plannedVsActualWeight?.planned || '-') +
                ' / ' +
                (keyMetrics?.plannedVsActualWeight?.actual || '-')
            "
            [infoIconSrc]="
                'assets/img/dashboard-key-metrics-icons/weight-icon.svg'
            "
            [infoIconAlt]="'Weight Icon'"
        ></app-key-metric>

        <app-key-metric
            [infoName]="'Active Cycle'"
            [infoValue]="keyMetrics?.activeCycle?.name ?? '-'"
            [infoIconSrc]="
                'assets/img/dashboard-key-metrics-icons/cycle-icon.svg'
            "
            [infoIconAlt]="'Cycle Icon'"
            [infoLink]="'placement'"
        ></app-key-metric>

        <app-key-metric
            [infoName]="'Active Alerts'"
            [infoValue]="keyMetrics?.activeAlerts ?? '-'"
            [infoIconSrc]="
                'assets/img/dashboard-key-metrics-icons/alert-icon.svg'
            "
            [infoIconAlt]="'Alert Icon'"
            [infoLink]="'notification-list'"
        ></app-key-metric>

        <app-key-metric
            [infoName]="'Active Medications'"
            [infoValue]="keyMetrics?.activeMedications ?? '-'"
            [infoIconSrc]="
                'assets/img/dashboard-key-metrics-icons/medicine-icon.svg'
            "
            [infoIconAlt]="'Medication Icon'"
            [infoLink]="'/task-list'"
        ></app-key-metric>

        <app-key-metric
            [infoName]="'Active Vaccinations'"
            [infoValue]="keyMetrics?.activeVaccinations ?? '-'"
            [infoIconSrc]="
                'assets/img/dashboard-key-metrics-icons/vaccine-icon.svg'
            "
            [infoIconAlt]="'Vaccine Icon'"
            [infoLink]="'/task-list'"
        ></app-key-metric>
    </div>
    <app-graph-item
        *ngIf="readingForm.get('farmId')?.value && loadGraphs"
        [farmId]="readingForm.get('farmId')?.value"
    ></app-graph-item>
    <app-environmental-time-series-graph
        *ngIf="readingForm.get('farmId')?.value && loadGraphs"
        [farmId]="readingForm.get('farmId')?.value"
    ></app-environmental-time-series-graph>
    <app-dashboard-insight-panel [farmId]="readingForm.get('farmId')?.value"></app-dashboard-insight-panel>
</div>
<p-dialog
    [(visible)]="displayfarm"
    modal="true"
    [style]="{width: '1200px'}"
    [closable]="false"
>
    <!-- <div class="text-left" (click)="closeDialog()"> <span class="fas fa-chevron-left"></span> Back</div> -->
    <ng-template pTemplate="content">
        <app-farm (close)="onCloseFarmDialog()"></app-farm>
    </ng-template>
</p-dialog>
